<header class="w-100 bg-white border-bottom">
  <div class="container-fluid d-flex align-items-center justify-content-between px-4 py-2">

    <!-- Left -->
    <div class="d-flex align-items-center">
      <img *ngIf="logoUrl"
        [src]="logoUrl"
        alt="Event logo"
        style="max-height: 70px; max-width: 200px; object-fit: contain;">
    </div>

    <!-- Right -->
    <div *ngIf="showUserInfo" class="d-flex align-items-center">

      <!-- User Info -->
      <div class="text-end me-3 mr-3">
        <div id="company-person-name-text">{{ personName }}</div>
        <div id="company-name-text" class="text-muted small">{{ companyName }}</div>
      </div>

      <!-- Logout -->
      <img src="assets/images/logout.png"
        alt="Logout"
        height="36"
        class="cursor-pointer"
        (click)="logout()">
    </div>

  </div>
</header>